import React, { Component } from "react";
import deleteButton from '@images/close.svg';
import addButton from '@images/addrow_icon.svg';
import SessionStateManager from "@components/SessionStateManager";
import ValidationsManager from "@components/ValidationsManager";
import styles from '../questionnaire.module.css';
import UpdateDialog from '@components/UpdateDialog';
import SupportAlert from "@components/SupportAlert";
import { CustomDialog, useDialog } from 'react-st-modal';

class SubsidiaryCompaniesQuestion extends Component {
    state = {
        loading: true,
        sessionStateChanged: false,
        subsidiaryValues: new Map(),
        subsidiaryRows: [],
        subsidiaryTotal: 0,
    }

    async componentDidMount() {
        this.setState({ loading: true });

        this.setState({ loading: false });
    }

    SUBSIDIARY_FACT_ID = this.props.questionState.questionFactStates.sort((a, b) => (a.sequenceNumberY > b.sequenceNumberY) ? 1 : -1)[0].questionFactId;
    CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD = 20;
    CONFIG_DEFAULT_MINIMUM_ROWS = 3;

    async handleOnChange(evt, questionFactId, ordinal) {
        let key = questionFactId + '_' + ordinal;
        let value = evt.target.value;

        if (this.props.captureType !== undefined && this.props.captureType !== null && this.props.captureType === 'RESEARCHER_UPDATE') {
            const result = await CustomDialog(
                <UpdateAuditDialog
                    currentAnswer={SessionStateManager.getSessionValue(key)}
                />,
                {
                    className: styles.updateAuditDialog,
                    title: 'Update Submitted Value',
                    showCloseIcon: false,
                    isFocusLock: true,
                    isCanClose: true, // setting this to false prevents the dialog from being closed when clicking away
                }
            );

            if (result !== undefined && result !== null && result.confirmed !== undefined && result.confirmed !== null && result.confirmed === true) {
                SessionStateManager.setSessionValueWithoutDependenciesValidation(key, result.newValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, result.sourceOfData, result.reason);
                this.setState({ sessionStateChanged: true });
            } else {
                evt.preventDefault();
            }

        } else {
            SessionStateManager.setSessionValueWithoutDependenciesValidation(key, value, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");

            for (let ord = 0; ord <= ordinal; ord++) {
                let thisKey = questionFactId + '_' + ord;
                let thisValue = SessionStateManager.getSessionValue(thisKey);
                thisValue = (thisValue !== undefined && thisValue !== null) ? thisValue : '';
                SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, thisValue, this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
            }

            this.setState({ sessionStateChanged: true });
        }

        if (this.props.onChange !== undefined && this.props.onChange !== null) {
            this.props.onChange(evt);
        }
    }

    handleOnBlur = (evt) => {
        if (this.props.onBlur !== undefined && this.props.onBlur !== null) {
            this.props.onBlur(evt);
        }
    }

    handleAddSubsidiaryRow = (evt, factIds) => {
        let rowsToAdd = parseInt(this.rowCountInput?.value || 1);
        if (rowsToAdd <= this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) {

            rowsToAdd = ((rowsToAdd > this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) ? (this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD) : rowsToAdd);
            const newRows = [];

            // If more rows are required, then lets always make sure that the default minimum rows are in the session state 
            for (let ordinal = 0; ordinal < this.CONFIG_DEFAULT_MINIMUM_ROWS; ordinal++) {
                factIds.forEach(factId => {
                    let thisKey = factId + '_' + ordinal;
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, '', this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }

                    if (SessionStateManager.hasSessionValueByKey(thisKey) && (SessionStateManager.getSessionValue(thisKey) === undefined || SessionStateManager.getSessionValue(thisKey) === null)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, '', this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }

                });
            }

            for (let offset = 0; offset < rowsToAdd; offset++) {
                const item = {
                    ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.subsidiaryRows.length + offset),
                    factIds: factIds
                };

                factIds.forEach(factId => {
                    let thisKey = factId + '_' + (this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.subsidiaryRows.length + offset).toString(); //
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, '', this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                });

                newRows.push(item);
            }

            this.setState({
                subsidiaryRows: [...this.state.subsidiaryRows, ...newRows],
                sessionStateChanged: true
            });
        } else {
            evt.preventDefault();
        }
    };

    addSubsidiaryRow = (rowsToAdd, factIds) => {
        if (rowsToAdd > 0) {
            let newRows = [];
            for (let offset = 0; offset < rowsToAdd; offset++) {
                const item = {
                    ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.subsidiaryRows.length + offset),
                    factIds: factIds
                };

                factIds.forEach(factId => {
                    let thisKey = factId + '_' + (this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.subsidiaryRows.length + offset).toString(); //
                    if (!SessionStateManager.hasSessionValueByKey(thisKey)) {
                        SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, '', this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId, "", "");
                    }
                });

                newRows.push(item);
            }
            this.setState({
                subsidiaryRows: [...this.state.subsidiaryRows, ...newRows],
                sessionStateChanged: true
            });

            const item = {
                ordinalEntry: parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + this.state.subsidiaryRows.length),
                factIds: factIds
            };
            this.setState({
                subsidiaryRows: [...this.state.subsidiaryRows, item]
            });
        }
    };

    handleRemoveSubsidiaryRow = (evt) => {

        if (this.state.subsidiaryRows.length > 0) {
            let rowToRemove = this.state.subsidiaryRows.sort((a, b) => a.ordinalEntry > b.ordinalEntry ? 1 : -1)[this.state.subsidiaryRows.length - 1];

            // Updating total by deleting all values for factIds of this row and re-calculating total
            rowToRemove?.factIds?.forEach(factId => {
                let thisKey = 'subsidiary_' + rowToRemove.ordinalEntry + '_' + factId
                this.state.subsidiaryValues.delete(thisKey);
            });

            rowToRemove?.factIds?.forEach(factId => {
                let thisKey = factId + '_' + rowToRemove.ordinalEntry;
                SessionStateManager.setSessionValueWithoutDependenciesValidation(thisKey, '', this.props.questionState.question.id, this.props.questionnairePartId, this.props.compoundQuestionStateId);
                SessionStateManager.deleteSessionValue(thisKey);
            });
            this.setState({ sessionStateChanged: true });

            this.setState({
                subsidiaryRows: this.state.subsidiaryRows.sort((a, b) => a.ordinalEntry > b.ordinalEntry ? 1 : -1).slice(0, -1)
            });
        }
    };

    render() {
        if (this.state.loading === true) {
            return <p>Loading...</p>
        } else {
            let rowFactIds = [this.SUBSIDIARY_FACT_ID];

            let initialRows = 0;

            let activitiesCount = SessionStateManager.countEntriesByQuestionFactId(this.SUBSIDIARY_FACT_ID);
            initialRows = activitiesCount;

            let rowsToAdd = (this.CONFIG_DEFAULT_MINIMUM_ROWS < initialRows) ? (initialRows - this.CONFIG_DEFAULT_MINIMUM_ROWS - this.state.subsidiaryRows.length) : 0;

            this.addSubsidiaryRow(rowsToAdd, rowFactIds);

            let defaultOrdinals = [];
            for (var ordinal = 0; ordinal < this.CONFIG_DEFAULT_MINIMUM_ROWS; ordinal++) {
                defaultOrdinals.push(ordinal);
            }

            return <div className={styles.SubsidiaryCompaniesQuestionContainer}>
                <table className="table">
                    <thead>
                        <tr>
                            <th width='5%' >Row</th>
                            <th width='95%' >Subsidiary Companies</th>
                        </tr>
                    </thead>
                    <tbody>
                        {defaultOrdinals.sort().map(ordinal => (
                            <tr>
                                <td key={'subsidiary_table_column_' + ordinal} className={styles.centerAlignVertically}>{ordinal + 1}</td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SUBSIDIARY_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : null}
                                >
                                    <input
                                        className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SUBSIDIARY_FACT_ID + '_' + ordinal) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                        type="text"
                                        questionId={this.props.questionState.question.id}
                                        ordinalEntry={ordinal}
                                        questionFactId={this.SUBSIDIARY_FACT_ID}
                                        value={SessionStateManager.getSessionValue(this.SUBSIDIARY_FACT_ID + '_' + ordinal)}
                                        onChange={evt => this.handleOnChange(evt, this.SUBSIDIARY_FACT_ID, ordinal)}
                                        onBlur={this.handleOnBlur}
                                        placeholder={'Subsidiary Company Name'}
                                    />
                                </td>
                            </tr>)
                        )}

                        {this.state.subsidiaryRows.map((item, idx) => (
                            <tr id="addr0" key={idx}>
                                <td key={'subsidiary_table_column_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)} className={styles.centerAlignVertically}>{parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx) + 1}</td>
                                <td
                                    className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SUBSIDIARY_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : null}
                                >
                                    <input
                                        className={ValidationsManager.hasValueBeenUpdated(this.props.captureType, this.SUBSIDIARY_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)) ? styles.tableInputBoxUpdated : styles.tableInputBox}
                                        type="text"
                                        questionId={this.props.questionState.question.id}
                                        ordinalEntry={parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx)}
                                        questionFactId={this.SUBSIDIARY_FACT_ID}
                                        value={SessionStateManager.getSessionValue(this.SUBSIDIARY_FACT_ID + '_' + parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx))}
                                        onChange={evt => this.handleOnChange(evt, this.SUBSIDIARY_FACT_ID, parseFloat(this.CONFIG_DEFAULT_MINIMUM_ROWS + idx))}
                                        onBlur={this.handleOnBlur}
                                        placeholder={'Subsidiary Company Name'}
                                    />
                                </td>
                            </tr>
                        ))}

                        <tr>
                            <td align='left' colSpan='2'>
                                <div>
                                    <span className={styles.cellHint}>
                                        <span className={styles.normalText}>
                                            <img
                                                src={addButton}
                                                alt="add row"
                                                onClick={(evt) => this.handleAddSubsidiaryRow(evt, rowFactIds)}
                                            />
                                            &nbsp;&nbsp; {'Add '}
                                            <input
                                                type="number"
                                                defaultValue="1"
                                                min="1"
                                                max={this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD}
                                                style={{ width: '60px', maxHeight: '20px', textAlign: 'center', border: '1px solid #ccc', borderRadius: '3px' }}
                                                ref={input => this.rowCountInput = input}
                                            /> additional rows
                                        </span>
                                        <span className={styles.tooltiptext}>
                                            {'A maximum of ' + this.CONFIG_DEFAULT_MAXIMUM_ROWS_TO_ADD + ' additional rows may be added at one time.'}
                                        </span>
                                    </span>
                                </div>
                                <br />
                                <div>
                                    <span className={styles.cellHint}>
                                        <span className={styles.normalText}>
                                            <img
                                                src={deleteButton}
                                                alt="delete row"
                                                onClick={this.handleRemoveSubsidiaryRow}
                                            />
                                            &nbsp;&nbsp; {'Remove last row only.'}
                                        </span>
                                        <span className={styles.tooltiptext}>
                                            {'Clicking this button will remove the last row from the table.'}<br />
                                            {'Note: The first 3 rows will always remain visible, as this is the configured mininmum rows to display. Any rows that were previously created may also remain visible.'}
                                        </span>
                                    </span>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        }
    }
}
export default SubsidiaryCompaniesQuestion;

function UpdateAuditDialog(props) {
    const dialog = useDialog();

    let componentRef = null;
    let result = {};
    result.confirmed = false;

    return (
        <div>
            <div
                className={styles.updateAuditDialogOverlay}
                ref={(response) => (componentRef = response)}
            >
                <UpdateDialog
                    currentAnswer={props.currentAnswer}
                    onChangeSourceOfData={(evt, newValue) => {
                        result.newValue = newValue;
                        result.sourceOfData = evt.target.value;
                    }}
                    onChangeReason={(evt, newValue) => {
                        result.newValue = newValue;
                        result.reason = evt.target.value
                    }}
                    onChangeNewValue={(evt) => {
                        result.newValue = evt.target.value
                    }}
                />
            </div>

            <div>
                <button
                    type="button"
                    className="btnBack"
                    onClick={(evt) => {
                        result.confirmed = false;
                        dialog.close(result);
                    }}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    className="btnNext"
                    onClick={(evt) => {
                        if (
                            result.sourceOfData === undefined || result.sourceOfData === null || result.sourceOfData.trim() === "" ||
                            result.reason === undefined || result.reason === null || result.reason.trim() === ""
                        ) {
                            SupportAlert.displayAlert('Required', 'Source of data and Reason are required fields.');
                        } else {
                            result.confirmed = true;
                            dialog.close(result);
                        }
                    }}
                >
                    Continue
                </button>
            </div>
        </div>
    );
}
